
'use client';

import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { motion } from 'framer-motion';
import { useTranslations } from 'next-intl';
import { Link } from '@/navigation';
import { ArrowRight } from 'lucide-react';

const HeroScene3D = dynamic(() => import('@/components/three/HeroScene3D'), { 
  ssr: false,
  loading: () => <div className="absolute inset-0 bg-black flex items-center justify-center">
    <div className="w-12 h-12 border-2 border-white/10 border-t-white rounded-full animate-spin" />
  </div>
});

export function Hero() {
  const t = useTranslations('hero');
  const [showScene, setShowScene] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowScene(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden bg-black">
      {/* 3D fon - GPU tezlashtirish uchun */}
      <div className="absolute inset-0 z-0 opacity-70 transform-gpu">
        {showScene && <HeroScene3D />}
      </div>

      {/* Kontent - Navbar balandligini hisobga olgan holda (h-20) */}
      <div className="container mx-auto px-6 relative z-10 text-center flex flex-col items-center justify-center min-h-screen pt-20">

        <motion.h1 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="text-4xl md:text-6xl font-extrabold tracking-tight text-white mb-6 transform-gpu"
        >
          {t('line1')} <span className="text-gray-400">{t('line2')}</span>
        </motion.h1>

        <motion.p 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4, ease: [0.16, 1, 0.3, 1] }}
          className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-12 leading-relaxed transform-gpu"
        >
          {t('subtitle')}
        </motion.p>

        <motion.div 
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col sm:flex-row items-center justify-center gap-4 transform-gpu"
        >
          <Link href="/#contact">
            <motion.button 
              className="w-full sm:w-auto flex items-center justify-center rounded-full px-8 py-3.5 bg-white text-black font-semibold transition-all"
              whileHover={{ scale: 1.05, backgroundColor: '#f0f0f0' }}
              whileTap={{ scale: 0.95 }}
            >
              {t('cta_primary')}
            </motion.button>
          </Link>
          <Link href="/projects">
            <motion.button 
              className="w-full sm:w-auto flex items-center justify-center gap-2 rounded-full px-8 py-3.5 bg-transparent text-white border border-white/20 font-semibold transition-all"
              whileHover={{ scale: 1.05, backgroundColor: 'rgba(255, 255, 255, 0.1)' }}
              whileTap={{ scale: 0.95 }}
            >
              {t('cta_secondary')} <ArrowRight size={20} />
            </motion.button>
          </Link>
        </motion.div>

      </div>
    </section>
  );
}
